import React from 'react';
import styles from './InvoiceDetail.module.css';
import {
  StatGrid, StatCard, StatLabel, StatValue, StatValueSm, StatValueMono, StatSub,
  NoticeBox,
  EarnCard, EarnCardHeader, EarnRow, EarnLabel, EarnValue,
} from './Styled';
import OrdersTable from './OrdersTable';
import { formatCurrency, formatNegative, formatDate, formatMonthYear } from '../utils';

const InvoiceDetail = ({ place, invoice, orders, selectedOrder, orderSearch, onSearchOrder, onSelectOrder }) => {
  if (!invoice) {
    return (
      <div className={styles.empty}>
        <div className={styles.emptyIcon}>←</div>
        <div className={styles.emptyTitle}>Select an invoice</div>
        <div className={styles.emptySub}>Choose a pay period from the list on the left</div>
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <StatGrid>
        <StatCard>
          <StatLabel>Total Payout</StatLabel>
          <StatValue>{formatCurrency(invoice.netPayout)}</StatValue>
          <StatSub>incl. GST</StatSub>
        </StatCard>
        <StatCard>
          <StatLabel>Completed Orders</StatLabel>
          <StatValue>{invoice.orderCount}</StatValue>
          <StatSub>{formatMonthYear(invoice.audit.createdAt)}</StatSub>
        </StatCard>
        <StatCard>
          <StatLabel>Invoice Date</StatLabel>
          <StatValueSm>{formatDate(invoice.audit.createdAt)}</StatValueSm>
          <StatSub>{invoice.city}, {invoice.state}</StatSub>
        </StatCard>
        <StatCard>
          <StatLabel>Place</StatLabel>
          <StatValueMono>{invoice.placeId.slice(0, 8).toUpperCase()}</StatValueMono>
          <StatSub>{place.name}</StatSub>
        </StatCard>
      </StatGrid>

      <NoticeBox>
        Invoice covers all completed orders processed on {formatDate(invoice.audit.createdAt)}.
        Payments are calculated based on sale value less KRAVEiN fees.
      </NoticeBox>

      <EarnCard>
        <EarnCardHeader>
          <span>Earnings Summary</span>
          <span>{place.name}</span>
        </EarnCardHeader>
        <EarnRow>
          <EarnLabel>Food Sales (incl. GST)</EarnLabel>
          <EarnValue>{formatCurrency(invoice.saleValue)}</EarnValue>
        </EarnRow>
        {invoice.promo < 0 && (
          <EarnRow>
            <EarnLabel>Promo Discount</EarnLabel>
            <EarnValue>{formatNegative(Math.abs(invoice.promo))}</EarnValue>
          </EarnRow>
        )}
        {invoice.venueCharges > 0 && (
          <EarnRow>
            <EarnLabel>Venue Charges</EarnLabel>
            <EarnValue>{formatCurrency(invoice.venueCharges)}</EarnValue>
          </EarnRow>
        )}
        <EarnRow>
          <EarnLabel>KRAVEiN Fees (incl. GST)</EarnLabel>
          <EarnValue>{formatNegative(invoice.kraveinFees)}</EarnValue>
        </EarnRow>
        <EarnRow total>
          <EarnLabel total>Net Payout (incl. GST)</EarnLabel>
          <EarnValue total>{formatCurrency(invoice.netPayout)}</EarnValue>
        </EarnRow>
      </EarnCard>

      <OrdersTable
        invoice={invoice}
        orders={orders}
        search={orderSearch}
        onSearchChange={onSearchOrder}
        selectedOrder={selectedOrder}
        onSelectOrder={onSelectOrder}
      />

      <div style={{ height: 20 }} />
    </div>
  );
};

export default InvoiceDetail;
